import './src/styles/_styles.sass';
import CombinedProvider from './src/shared/context/combined-provider';
import RootProvider, { RootProviderType } from './src/shared/context/root-provider';
import React from 'react'
export const wrapRootElement = ({ element }) => (
  <RootProvider>
    {element}
  </RootProvider>
);
